export default /* @ngInject */ ($window, $templateCache, $interval) => {
    let $win,
        $next,
        $prev,
        $items,
        $element,
        winWidth,
        scrollWidth,
        selectorRaw,
        animDuration,
        stickableWidth,
        nCurrentPosition,
        $nScrollableItem,
        nCurrentScrollPos;

    const template = `<div class='scrollable-ctrl' ng-transclude>
                          </div>`;

    const adjustController = (attrs) => {
        getWidth();
        const stickableScrollable = $(`${attrs.stickable}`);
        const scrollPos = $win.scrollTop();
        const stickAt = 450;
        var currentWindow = window.location.hash;
        let styles;

        if (attrs.stickableStyles) {
            styles = attrs.stickableStyles;
        }
        else if (currentWindow == "#!/income-vs-budget"){
            styles = `
                left: 19em;
                top: 0em;
                z-index: 10;
                position: fixed;
                background-color: #0064a2;
                width: ${stickableWidth ? stickableWidth + '.5px' : '82.5%'};
            `;
        }
        else {
            styles = `
                left: 16%;
                top: 0.0em;
                z-index: 10;
                position: fixed;
                background-color: #0064a2;
                width: ${stickableWidth ? stickableWidth + '.5px' : '82.5%'};
            `;
        }

        if (stickableWidth) {
            styles += `
                    width: ${stickableWidth}.5px;
                `;
        }

        const $otherScrollable = angular.element(angular.element('#reserve-')[0]);
        if ($otherScrollable && $otherScrollable.length > 0) {
            if ($otherScrollable.css('display') !== 'none') {
                const shouldHideMainScrollable = isElementNotBeingShown($otherScrollable[0]);
                styles += `display: ${shouldHideMainScrollable ? 'none' : 'flex'};`;
            }
        }

        if (scrollPos >= stickAt) {
            stickableScrollable.attr('style', styles);
            stickableScrollable.addClass('is-showing');
        } else {
            stickableScrollable.attr('style', '');
            stickableScrollable.removeClass('is-showing');
        }
    };

    const scrollDir = (dir) => {
        const ntotalScrollableCols = 12;
        const monthlyActualContainerWidth = $('.monthly-actual-container').width();
        const nScrollAmount = $('.months-column').width();
        const limitScrolls = Math.trunc(monthlyActualContainerWidth / nScrollAmount);
        const $nScrollableItem = $('.scroll-me');

        if (dir === 'left') {
            if (nCurrentPosition > 0) {
                nCurrentScrollPos += nScrollAmount;

                $nScrollableItem.css({
                    transition: 'transform .5s',
                    transform: `translateX(${nCurrentScrollPos}px)`
                });
                nCurrentPosition -= 1;
            }
        }

        if (dir === 'right') {
            if (nCurrentPosition < ntotalScrollableCols - limitScrolls) {
                nCurrentScrollPos -= nScrollAmount;

                $nScrollableItem.css({
                    transition: 'transform .5s',
                    transform: `translateX(${nCurrentScrollPos}px)`
                });
                nCurrentPosition += 1;
            }
        }
    };

    const getWidth = () => {
        stickableWidth = $('.panel-group .months-container').width();
    };

    const init = () => {
        $win = $($window);
        nCurrentPosition = 0;
        nCurrentScrollPos = 0;
        $next = $('[data-ctrl=next]');
        $prev = $('[data-ctrl=prev]');
    };

    /**
     * Checks if an element is currently being shown in view
     * @param {HtmlElement} el The element to check
     */
    const isElementNotBeingShown = (el) => {
        if (!el) {
            return false;
        }

        let top = el.offsetTop;
        let left = el.offsetLeft;
        const width = el.offsetWidth;
        const height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < window.pageYOffset + window.innerHeight &&
            left < window.pageXOffset + window.innerWidth &&
            top + height > window.pageYOffset &&
            left + width > window.pageXOffset
        );
    };

    return {
        template,
        scope: {
            fixed: '=?',
            stickAt: '@',
            stickable: '@',
            targetSelector: '@',
            stickableStyles: '@'
        },
        transclude: true,
        link: (scope, element, attrs) => {
            $element = $(element);
            init();

            if (attrs.hasOwnProperty('stickable') && attrs.stickable) {
                adjustController(attrs);

                const scrollEventHandler = _.throttle((evt) => {
                    evt.preventDefault();
                    adjustController(attrs);
                }, 100);

                $win.on('scroll', scrollEventHandler);
            }

            [ $prev, $next ].forEach(($el) => {
                $el.on('mousedown mouseup click', (evt) => evt.preventDefault());

                $el.on('click', (evt) => {
                    const dir = $(evt.currentTarget).hasClass('next') ? 'right' : 'left';
                    scrollDir(dir);
                });
            });

            $win.on('resize', () => {
                winWidth = $win.width();
                getWidth();
                adjustController(attrs);
            });
        }
    };
};
